module.exports = __webpack_public_path__ + "static/media/dzoff.4b2367e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dzoff.png
// module id = 382
// module chunks = 0 1